import { getUserToken, getBackendBaseUrl } from "@/utils/common"
import axios from "axios"

const baseUrl : string = getBackendBaseUrl()

const User = () => {

   const getHeaders = () => { 
      return {
         'Authorization': `Bearer ${getUserToken()}`,
         'Content-Type': 'application/json',
      }
   }

   const userProfile = async () : Promise<any> => {
      try {
         const response = await axios.get(`${baseUrl}api/web/profile`, {params: {}, headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const userProfileSave = async (data: any, type: 'personal' | 'password') : Promise<any> => {
      let response
      try {
         if (type == 'personal') {
            response = await axios.post(baseUrl + 'api/web/profile', {name: data.fullName, phone: data.phone, photo: data.photo, country: data.country}, {headers: getHeaders()})
         } else {
            response = await axios.post(baseUrl + 'api/web/password', {currentPassword: data.current, newPassword: data.new, passwordConfirmation: data.confirmNew}, {headers: getHeaders()})
         }

         return response
      } catch (err : any) {
         return err
      }
   }

   const customerLoyaltyLogs = async () : Promise<any> => {
      try {
         const response = await axios.get(`${baseUrl}api/web/loyalty`, {params: {}, headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const customerRequestRedeemLoyalty = async (bankName: string, accountName: string, accountNumber: string, countryName: string, points?: number) : Promise<any> => {
      try {
         const response = await axios.post(`${baseUrl}api/web/loyalty/withdraw`, {
            bankName,
            accountName,
            accountNumber,
            countryName,
            points
         }, {headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   return {
      userProfile,
      userProfileSave,
      customerLoyaltyLogs,
      customerRequestRedeemLoyalty
   }
}

export default User
